export const softwareList = [
  {
    id: "jzh-terminal",
    name: "金智汇行情终端",
    categoryId: "trend",
    categoryName: "趋势分析软件",
    subCategory: "实时行情",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20gold%20investment%20trading%20terminal%20software%20interface%20on%20a%20desktop%20monitor%2C%20deep%20navy%20background%20with%20glowing%20golden%20candlestick%20charts%2C%20professional%20financial%20dashboard%2C%20elegant%20minimal%20UI%2C%20soft%20gold%20lighting%2C%20high%20detail%20clean%20composition&width=640&height=420&seq=sw-jzh-cover&orientation=landscape",
    screenshots: [
      "https://readdy.ai/api/search-image?query=Gold%20investment%20terminal%20multi%20timeframe%20candlestick%20chart%20screen%2C%20deep%20navy%20interface%20with%20golden%20trend%20lines%20and%20moving%20averages%2C%20professional%20financial%20software%20dashboard%2C%20minimal%20elegant%20UI%2C%20soft%20glow%2C%20high%20detail&width=800&height=600&seq=sw-jzh-shot1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Technical%20indicator%20panel%20of%20a%20gold%20trading%20desktop%20application%2C%20navy%20dark%20theme%20with%20gold%20and%20warm%20accents%2C%20RSI%20and%20MACD%20charts%2C%20clean%20financial%20data%20visualization%2C%20modern%20software%20UI%2C%20high%20detail&width=800&height=600&seq=sw-jzh-shot2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Gold%20market%20watchlist%20and%20order%20book%20screen%20of%20a%20professional%20trading%20terminal%2C%20dark%20navy%20background%20with%20golden%20numbers%20and%20tables%2C%20sleek%20fintech%20dashboard%20UI%2C%20soft%20ambient%20light%2C%20high%20detail&width=800&height=600&seq=sw-jzh-shot3&orientation=landscape",
    ],
    intro: "专业级伦敦金与现货黄金实时行情终端，支持多周期K线、指标组合与智能信号提醒。",
    description:
      "金智汇行情终端是一款面向中高级投资者的专业黄金行情分析软件，聚合伦敦金、现货黄金、黄金期货等多个市场数据，提供毫秒级行情推送。软件内置 40 余种技术指标与画线工具，支持自定义多屏工作区，让你在同一界面同时跟踪走势、指标与持仓，快速捕捉趋势拐点。",
    features: [
      "毫秒级实时行情推送，多市场数据聚合",
      "40+ 技术指标可自由组合与叠加",
      "自定义多屏工作区，布局随时保存",
      "智能买卖信号与趋势强度提醒",
    ],
    version: "4.2.1",
    size: "86.4 MB",
    platforms: ["Windows", "macOS", "Android", "iOS"],
    updatedAt: "2026-09-28",
    downloads: 1286400,
    rating: 4.8,
    free: true,
    officialUrl: "https://example.com/download/jzh-terminal",
    tags: ["实时行情", "技术分析", "多屏看盘"],
  },
  {
    id: "spot-master",
    name: "现货黄金分析大师",
    categoryId: "trend",
    categoryName: "趋势分析软件",
    subCategory: "技术指标",
    cover:
      "https://readdy.ai/api/search-image?query=Spot%20gold%20technical%20analysis%20software%20interface%20on%20a%20laptop%20screen%2C%20deep%20navy%20theme%20with%20golden%20chart%20lines%20and%20oscillator%20panels%2C%20professional%20financial%20analysis%20tool%2C%20elegant%20minimal%20design%2C%20soft%20warm%20lighting%2C%20high%20detail&width=640&height=420&seq=sw-spot-cover&orientation=landscape",
    screenshots: [
      "https://readdy.ai/api/search-image?query=Gold%20price%20technical%20analysis%20workspace%20with%20trend%20channel%20drawing%20tools%2C%20navy%20dark%20UI%20with%20golden%20annotations%2C%20professional%20charting%20software%2C%20clean%20layout%2C%20soft%20glow%2C%20high%20detail&width=800&height=600&seq=sw-spot-shot1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Indicator%20library%20panel%20of%20a%20gold%20analysis%20application%2C%20deep%20navy%20background%20with%20gold%20highlighted%20indicators%20list%2C%20modern%20fintech%20UI%2C%20organized%20grid%20layout%2C%20high%20detail&width=800&height=600&seq=sw-spot-shot2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Gold%20pattern%20recognition%20result%20screen%20showing%20signals%20on%20chart%2C%20navy%20theme%20with%20warm%20gold%20markers%2C%20professional%20trading%20software%20UI%2C%20soft%20ambient%20light%2C%20high%20detail&width=800&height=600&seq=sw-spot-shot3&orientation=landscape",
    ],
    intro: "以指标组合与形态识别为核心的分析工具，内置多套经典黄金交易策略模板。",
    description:
      "现货黄金分析大师聚焦技术分析场景，内置均线、布林带、MACD 等经典指标的智能组合方案，并提供形态自动识别与策略回测功能。软件内置多套面向黄金市场的交易模板，新手可一键套用，高手可深度自定义，帮助你在不同市场阶段选择更合适的分析框架。",
    features: [
      "形态自动识别，标注关键反转信号",
      "多套黄金交易策略模板一键套用",
      "策略回测与历史胜率统计",
      "画线工具与指标组合可保存复用",
    ],
    version: "3.8.0",
    size: "72.1 MB",
    platforms: ["Windows", "macOS", "Android"],
    updatedAt: "2026-09-15",
    downloads: 934200,
    rating: 4.6,
    free: true,
    officialUrl: "https://example.com/download/spot-master",
    tags: ["形态识别", "策略模板", "回测"],
  },
  {
    id: "huijin-treasury",
    name: "汇金宝典",
    categoryId: "trend",
    categoryName: "趋势分析软件",
    subCategory: "智能预警",
    cover:
      "https://readdy.ai/api/search-image?query=Smart%20gold%20price%20alert%20software%20interface%20with%20notification%20cards%2C%20deep%20navy%20background%20and%20golden%20accent%20elements%2C%20professional%20financial%20tool%2C%20minimal%20elegant%20UI%2C%20soft%20glow%2C%20high%20detail&width=640&height=420&seq=sw-huijin-cover&orientation=landscape",
    screenshots: [
      "https://readdy.ai/api/search-image?query=Gold%20price%20alert%20rule%20configuration%20screen%2C%20navy%20dark%20UI%20with%20golden%20toggle%20controls%2C%20professional%20financial%20software%2C%20organized%20settings%20layout%2C%20high%20detail&width=800&height=600&seq=sw-huijin-shot1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Market%20signal%20feed%20list%20in%20a%20gold%20trading%20app%2C%20deep%20navy%20theme%20with%20warm%20gold%20badges%2C%20modern%20fintech%20interface%2C%20clean%20cards%2C%20soft%20ambient%20light%2C%20high%20detail&width=800&height=600&seq=sw-huijin-shot2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Trend%20strength%20gauge%20dashboard%20of%20a%20gold%20analysis%20app%2C%20navy%20dark%20background%20with%20golden%20progress%20rings%2C%20professional%20financial%20data%20visualization%2C%20high%20detail&width=800&height=600&seq=sw-huijin-shot3&orientation=landscape",
    ],
    intro: "以智能预警与信号推送见长的黄金行情工具，重要点位变化第一时间提醒。",
    description:
      "汇金宝典主打智能预警，支持按价格、涨跌幅、指标交叉等条件自由设置提醒规则，重要点位触发时通过应用内与系统通知双重提醒。软件还会根据趋势强度生成信号评分，帮助你在行情剧烈波动时保持理性判断，避免情绪化追涨杀跌。",
    features: [
      "多条件自定义预警规则",
      "系统通知与应用内双重提醒",
      "趋势强度评分与信号分级",
      "重要财经日历事件提前提醒",
    ],
    version: "2.9.5",
    size: "58.7 MB",
    platforms: ["Android", "iOS", "Windows"],
    updatedAt: "2026-08-30",
    downloads: 612800,
    rating: 4.5,
    free: true,
    officialUrl: "https://example.com/download/huijin-treasury",
    tags: ["智能预警", "信号推送", "财经日历"],
  },
  {
    id: "gold-radar",
    name: "金价雷达",
    categoryId: "monitor",
    categoryName: "价格监控APP",
    subCategory: "到价提醒",
    cover:
      "https://readdy.ai/api/search-image?query=Lightweight%20gold%20price%20monitor%20mobile%20app%20interface%2C%20deep%20navy%20phone%20screen%20with%20golden%20price%20cards%20and%20radar%20motif%2C%20minimal%20fintech%20design%2C%20soft%20warm%20glow%2C%20high%20detail&width=640&height=420&seq=sw-radar-cover&orientation=landscape",
    screenshots: [
      "https://readdy.ai/api/search-image?query=Gold%20price%20target%20alert%20setup%20screen%20on%20mobile%2C%20navy%20dark%20UI%20with%20golden%20slider%20control%2C%20clean%20fintech%20app%20design%2C%20high%20detail&width=800&height=600&seq=sw-radar-shot1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Live%20gold%20price%20widget%20list%20in%20a%20monitoring%20app%2C%20deep%20navy%20background%20with%20golden%20numbers%20and%20mini%20sparklines%2C%20modern%20mobile%20UI%2C%20high%20detail&width=800&height=600&seq=sw-radar-shot2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Price%20movement%20history%20timeline%20in%20a%20gold%20tracking%20app%2C%20navy%20theme%20with%20warm%20gold%20markers%2C%20elegant%20minimal%20fintech%20interface%2C%20high%20detail&width=800&height=600&seq=sw-radar-shot3&orientation=landscape",
    ],
    intro: "轻量金价监控应用，到价提醒与涨跌推送一手掌握，启动快、耗电低。",
    description:
      "金价雷达是一款极简的金价监控应用，安装包小巧、启动迅速。你可以把常看的黄金品种固定在桌面小组件上，设置到价提醒后无需打开应用也能收到推送。应用还记录关键价格变动的时间线，方便复盘每一次重要波动。",
    features: [
      "桌面小组件实时展示金价",
      "到价提醒与涨跌幅阈值提醒",
      "价格变动时间线复盘",
      "轻量省电，长期后台监控",
    ],
    version: "5.0.2",
    size: "32.6 MB",
    platforms: ["Android", "iOS"],
    updatedAt: "2026-10-02",
    downloads: 1842300,
    rating: 4.7,
    free: true,
    officialUrl: "https://example.com/download/gold-radar",
    tags: ["到价提醒", "桌面小组件", "轻量"],
  },
  {
    id: "zhaocai-gold",
    name: "招财金APP",
    categoryId: "monitor",
    categoryName: "价格监控APP",
    subCategory: "涨跌推送",
    cover:
      "https://readdy.ai/api/search-image?query=Gold%20price%20push%20notification%20app%20interface%20on%20smartphone%2C%20deep%20navy%20screen%20with%20golden%20price%20ticker%20and%20alert%20badges%2C%20warm%20prosperous%20fintech%20style%2C%20soft%20glow%2C%20high%20detail&width=640&height=420&seq=sw-zhaocai-cover&orientation=landscape",
    screenshots: [
      "https://readdy.ai/api/search-image?query=Gold%20price%20change%20push%20notification%20card%20design%2C%20navy%20background%20with%20golden%20up%20arrow%20accent%2C%20clean%20fintech%20mobile%20UI%2C%20high%20detail&width=800&height=600&seq=sw-zhaocai-shot1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Watchlist%20management%20screen%20of%20a%20gold%20tracking%20app%2C%20deep%20navy%20theme%20with%20golden%20reorder%20handles%2C%20modern%20mobile%20interface%2C%20high%20detail&width=800&height=600&seq=sw-zhaocai-shot2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Daily%20gold%20market%20summary%20report%20screen%2C%20navy%20dark%20UI%20with%20warm%20gold%20charts%2C%20fintech%20app%20design%2C%20soft%20ambient%20light%2C%20high%20detail&width=800&height=600&seq=sw-zhaocai-shot3&orientation=landscape",
    ],
    intro: "以涨跌推送为核心的黄金监控助手，自选列表自由排序，异动即时提醒。",
    description:
      "招财金APP把黄金价格的每一次异动都推送给你，支持自选品种分组管理、涨跌幅阈值提醒与每日行情小结。界面以暖金与藏青为主，专业中带着招财纳福的好寓意，适合每天关注金价的投资者快速浏览。",
    features: [
      "自选品种分组与拖拽排序",
      "涨跌幅阈值即时推送",
      "每日行情小结自动生成",
      "多设备同步自选列表",
    ],
    version: "3.4.0",
    size: "41.8 MB",
    platforms: ["Android", "iOS"],
    updatedAt: "2026-09-20",
    downloads: 976500,
    rating: 4.6,
    free: true,
    officialUrl: "https://example.com/download/zhaocai-gold",
    tags: ["涨跌推送", "自选管理", "行情小结"],
  },
  {
    id: "gold-housekeeper",
    name: "金价管家",
    categoryId: "monitor",
    categoryName: "价格监控APP",
    subCategory: "走势追踪",
    cover:
      "https://readdy.ai/api/search-image?query=Gold%20price%20trend%20tracking%20app%20interface%2C%20deep%20navy%20mobile%20screen%20with%20golden%20line%20chart%20and%20tracking%20markers%2C%20professional%20minimal%20fintech%20design%2C%20soft%20glow%2C%20high%20detail&width=640&height=420&seq=sw-housekeeper-cover&orientation=landscape",
    screenshots: [
      "https://readdy.ai/api/search-image?query=Gold%20price%20intraday%20trend%20chart%20screen%2C%20navy%20dark%20UI%20with%20golden%20area%20chart%20gradient%2C%20clean%20mobile%20fintech%20design%2C%20high%20detail&width=800&height=600&seq=sw-housekeeper-shot1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Multi%20period%20gold%20trend%20comparison%20view%2C%20deep%20navy%20background%20with%20warm%20gold%20overlay%20lines%2C%20modern%20app%20interface%2C%20high%20detail&width=800&height=600&seq=sw-housekeeper-shot2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Gold%20trend%20annotation%20and%20note%20feature%20screen%2C%20navy%20theme%20with%20golden%20sticky%20notes%2C%20elegant%20fintech%20app%20UI%2C%20soft%20light%2C%20high%20detail&width=800&height=600&seq=sw-housekeeper-shot3&orientation=landscape",
    ],
    intro: "多周期走势追踪与标注工具，把每一次判断记录下来，形成自己的看盘笔记。",
    description:
      "金价管家专注于走势追踪，支持分时、日线、周线等多周期切换与叠加对比，还能在走势图上直接添加标注和笔记。长期使用下来，你会拥有一份属于自己的黄金看盘笔记，让经验沉淀为可复用的判断依据。",
    features: [
      "多周期走势切换与叠加对比",
      "走势图标注与看盘笔记",
      "关键点位自动标记",
      "历史笔记检索与回顾",
    ],
    version: "2.6.3",
    size: "38.2 MB",
    platforms: ["Android", "iOS", "Windows"],
    updatedAt: "2026-08-12",
    downloads: 428900,
    rating: 4.4,
    free: true,
    officialUrl: "https://example.com/download/gold-housekeeper",
    tags: ["走势追踪", "看盘笔记", "多周期"],
  },
  {
    id: "gold-accumulator",
    name: "黄金定投助手",
    categoryId: "finance",
    categoryName: "黄金理财工具",
    subCategory: "定投计划",
    cover:
      "https://readdy.ai/api/search-image?query=Gold%20savings%20plan%20investment%20app%20interface%2C%20deep%20navy%20phone%20screen%20with%20golden%20coin%20illustration%20and%20plan%20cards%2C%20warm%20professional%20fintech%20design%2C%20soft%20glow%2C%20high%20detail&width=640&height=420&seq=sw-accum-cover&orientation=landscape",
    screenshots: [
      "https://readdy.ai/api/search-image?query=Gold%20accumulation%20plan%20setup%20screen%20with%20calendar%20and%20amount%20selector%2C%20navy%20dark%20UI%20with%20golden%20accent%20controls%2C%20clean%20fintech%20app%20design%2C%20high%20detail&width=800&height=600&seq=sw-accum-shot1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Gold%20investment%20return%20calculator%20screen%2C%20deep%20navy%20theme%20with%20golden%20donut%20chart%20and%20numbers%2C%20professional%20financial%20app%20UI%2C%20high%20detail&width=800&height=600&seq=sw-accum-shot2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Gold%20accumulation%20progress%20tracking%20dashboard%2C%20navy%20background%20with%20warm%20gold%20progress%20rings%2C%20elegant%20fintech%20mobile%20interface%2C%20high%20detail&width=800&height=600&seq=sw-accum-shot3&orientation=landscape",
    ],
    intro: "黄金积存与定投计划助手，支持收益测算与定投进度追踪，长期配置更省心。",
    description:
      "黄金定投助手面向长期配置黄金的用户，提供定投计划设置、收益测算与进度追踪。你可以设定每周或每月的定投金额，应用会自动记录每一次买入、计算平均成本与累计收益，帮助你在金价波动中保持纪律，平滑持仓成本。",
    features: [
      "每周/每月定投计划一键设置",
      "平均成本与累计收益自动计算",
      "定投进度与持仓曲线追踪",
      "收益测算器前置规划更清晰",
    ],
    version: "3.1.0",
    size: "46.5 MB",
    platforms: ["Android", "iOS"],
    updatedAt: "2026-09-25",
    downloads: 735600,
    rating: 4.7,
    free: true,
    officialUrl: "https://example.com/download/gold-accumulator",
    tags: ["黄金定投", "收益测算", "持仓管理"],
  },
  {
    id: "jinding-wealth",
    name: "金鼎理财通",
    categoryId: "finance",
    categoryName: "黄金理财工具",
    subCategory: "收益测算",
    cover:
      "https://readdy.ai/api/search-image?query=Comprehensive%20gold%20wealth%20management%20app%20interface%2C%20deep%20navy%20screen%20with%20golden%20portfolio%20charts%20and%20assets%20cards%2C%20premium%20professional%20fintech%20design%2C%20soft%20glow%2C%20high%20detail&width=640&height=420&seq=sw-jinding-cover&orientation=landscape",
    screenshots: [
      "https://readdy.ai/api/search-image?query=Gold%20asset%20allocation%20dashboard%20screen%2C%20navy%20dark%20UI%20with%20golden%20pie%20chart%20and%20allocation%20bars%2C%20professional%20financial%20app%20design%2C%20high%20detail&width=800&height=600&seq=sw-jinding-shot1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Gold%20investment%20return%20analysis%20screen%2C%20deep%20navy%20theme%20with%20warm%20gold%20line%20charts%2C%20elegant%20fintech%20mobile%20UI%2C%20high%20detail&width=800&height=600&seq=sw-jinding-shot2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Wealth%20goal%20planning%20card%20screen%20in%20a%20gold%20finance%20app%2C%20navy%20background%20with%20golden%20milestone%20markers%2C%20modern%20financial%20interface%2C%20high%20detail&width=800&height=600&seq=sw-jinding-shot3&orientation=landscape",
    ],
    intro: "综合性黄金资产配置工具，聚合持仓、收益与目标规划于一张清晰看板。",
    description:
      "金鼎理财通把黄金相关的资产配置集中在一张看板上，支持记录实物金、积存金、黄金ETF等多种持仓，自动汇总总资产与收益表现。你可以设定理财目标并跟踪完成进度，让黄金资产在家庭配置中的角色一目了然。",
    features: [
      "多类型黄金持仓集中管理",
      "资产配置与收益表现看板",
      "理财目标设定与进度跟踪",
      "月度收益报告自动生成",
    ],
    version: "4.0.6",
    size: "64.3 MB",
    platforms: ["Android", "iOS", "Windows"],
    updatedAt: "2026-08-05",
    downloads: 552300,
    rating: 4.5,
    free: true,
    officialUrl: "https://example.com/download/jinding-wealth",
    tags: ["资产配置", "收益看板", "目标规划"],
  },
  {
    id: "gold-palm",
    name: "掌上金行",
    categoryId: "finance",
    categoryName: "黄金理财工具",
    subCategory: "持仓管理",
    cover:
      "https://readdy.ai/api/search-image?query=Pocket%20gold%20investment%20management%20app%20interface%2C%20deep%20navy%20phone%20screen%20with%20golden%20holdings%20cards%20and%20coins%2C%20clean%20premium%20fintech%20design%2C%20soft%20glow%2C%20high%20detail&width=640&height=420&seq=sw-palm-cover&orientation=landscape",
    screenshots: [
      "https://readdy.ai/api/search-image?query=Gold%20holdings%20detail%20list%20screen%2C%20navy%20dark%20UI%20with%20golden%20profit%20numbers%20and%20badges%2C%20professional%20financial%20app%20design%2C%20high%20detail&width=800&height=600&seq=sw-palm-shot1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Buy%20and%20sell%20record%20timeline%20in%20a%20gold%20finance%20app%2C%20deep%20navy%20theme%20with%20warm%20gold%20markers%2C%20elegant%20mobile%20interface%2C%20high%20detail&width=800&height=600&seq=sw-palm-shot2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Gold%20profit%20and%20loss%20summary%20screen%2C%20navy%20background%20with%20golden%20gain%20charts%2C%20modern%20fintech%20app%20UI%2C%20soft%20ambient%20light%2C%20high%20detail&width=800&height=600&seq=sw-palm-shot3&orientation=landscape",
    ],
    intro: "聚焦持仓记录与盈亏统计的记账工具，把每一笔黄金买卖都管理得清清楚楚。",
    description:
      "掌上金行是一款专注持仓管理的黄金记账工具，支持手动记录买入卖出、自动计算持仓成本与浮动盈亏，并以时间线回顾每一笔交易。界面清爽、操作简单，适合习惯自己记录账目、追求清晰的投资者。",
    features: [
      "买卖记录快速记账",
      "持仓成本与浮盈浮亏自动计算",
      "交易时间线回顾",
      "盈亏汇总与阶段统计",
    ],
    version: "2.8.4",
    size: "35.9 MB",
    platforms: ["Android", "iOS"],
    updatedAt: "2026-09-08",
    downloads: 389400,
    rating: 4.4,
    free: true,
    officialUrl: "https://example.com/download/gold-palm",
    tags: ["持仓管理", "盈亏统计", "记账"],
  },
  {
    id: "gold-eye-news",
    name: "黄金眼资讯",
    categoryId: "news",
    categoryName: "行情资讯平台",
    subCategory: "深度研报",
    cover:
      "https://readdy.ai/api/search-image?query=Gold%20market%20news%20and%20research%20app%20interface%2C%20deep%20navy%20screen%20with%20golden%20article%20cards%20and%20chart%20thumbnails%2C%20professional%20editorial%20fintech%20design%2C%20soft%20glow%2C%20high%20detail&width=640&height=420&seq=sw-eye-cover&orientation=landscape",
    screenshots: [
      "https://readdy.ai/api/search-image?query=Gold%20market%20research%20report%20reading%20screen%2C%20navy%20dark%20UI%20with%20golden%20section%20headers%20and%20charts%2C%20editorial%20fintech%20app%20design%2C%20high%20detail&width=800&height=600&seq=sw-eye-shot1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=News%20feed%20list%20of%20a%20gold%20information%20app%2C%20deep%20navy%20background%20with%20warm%20gold%20category%20tags%2C%20clean%20mobile%20interface%2C%20high%20detail&width=800&height=600&seq=sw-eye-shot2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Expert%20commentary%20column%20screen%20in%20a%20gold%20news%20app%2C%20navy%20theme%20with%20golden%20author%20avatars%2C%20elegant%20financial%20editorial%20UI%2C%20high%20detail&width=800&height=600&seq=sw-eye-shot3&orientation=landscape",
    ],
    intro: "聚合黄金市场快讯、机构研报与专家观点的资讯平台，帮你读懂金价背后的逻辑。",
    description:
      "黄金眼资讯每日更新黄金市场快讯与机构研报，并邀请分析师撰写深度观点。平台以标签化方式组织内容，覆盖美联储政策、地缘避险、实物需求等主题，让你在碎片时间也能系统了解影响金价的核心因素，理清行情驱动逻辑。",
    features: [
      "7×24 小时黄金市场快讯",
      "机构研报与深度文章聚合",
      "专家观点专栏与作者订阅",
      "主题标签化内容组织，检索方便",
    ],
    version: "5.2.0",
    size: "52.8 MB",
    platforms: ["Android", "iOS", "Web"],
    updatedAt: "2026-10-08",
    downloads: 1428700,
    rating: 4.8,
    free: true,
    officialUrl: "https://example.com/download/gold-eye-news",
    tags: ["市场快讯", "机构研报", "专家观点"],
  },
  {
    id: "caijing-gold",
    name: "财经金银通",
    categoryId: "news",
    categoryName: "行情资讯平台",
    subCategory: "实时快讯",
    cover:
      "https://readdy.ai/api/search-image?query=Real%20time%20financial%20news%20app%20for%20gold%20and%20silver%2C%20deep%20navy%20screen%20with%20golden%20ticker%20lines%20and%20news%20cards%2C%20authoritative%20professional%20fintech%20design%2C%20soft%20glow%2C%20high%20detail&width=640&height=420&seq=sw-caijing-cover&orientation=landscape",
    screenshots: [
      "https://readdy.ai/api/search-image?query=Breaking%20news%20flash%20screen%20in%20a%20financial%20app%2C%20navy%20dark%20UI%20with%20golden%20breaking%20badge%2C%20clean%20mobile%20news%20interface%2C%20high%20detail&width=800&height=600&seq=sw-caijing-shot1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Economic%20calendar%20and%20data%20release%20screen%2C%20deep%20navy%20theme%20with%20warm%20gold%20event%20markers%2C%20professional%20financial%20app%20design%2C%20high%20detail&width=800&height=600&seq=sw-caijing-shot2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Gold%20and%20silver%20price%20chart%20embedded%20in%20news%20article%2C%20navy%20background%20with%20golden%20curves%2C%20elegant%20fintech%20editorial%20UI%2C%20high%20detail&width=800&height=600&seq=sw-caijing-shot3&orientation=landscape",
    ],
    intro: "面向黄金与白银投资者的实时财经快讯平台，重大数据与政策第一时间解读。",
    description:
      "财经金银通专注于黄金与白银相关的财经资讯，重大数据发布、央行政策调整第一时间推送。每一条快讯都附有简明的市场解读，帮助忙碌的投资者用最少的时间抓住关键信息，快速判断事件对金价的潜在影响。",
    features: [
      "重大财经数据实时快讯推送",
      "每条快讯附简明市场解读",
      "财经日历事件提前预告",
      "黄金白银品种专属频道",
    ],
    version: "4.6.1",
    size: "49.2 MB",
    platforms: ["Android", "iOS"],
    updatedAt: "2026-09-30",
    downloads: 1043600,
    rating: 4.6,
    free: true,
    officialUrl: "https://example.com/download/caijing-gold",
    tags: ["实时快讯", "财经日历", "白银"],
  },
  {
    id: "taojin-express",
    name: "淘金者快讯",
    categoryId: "news",
    categoryName: "行情资讯平台",
    subCategory: "专家观点",
    cover:
      "https://readdy.ai/api/search-image?query=Gold%20investor%20community%20insight%20app%20interface%2C%20deep%20navy%20screen%20with%20golden%20analyst%20columns%20and%20opinion%20cards%2C%20modern%20fintech%20editorial%20design%2C%20soft%20glow%2C%20high%20detail&width=640&height=420&seq=sw-taojin-cover&orientation=landscape",
    screenshots: [
      "https://readdy.ai/api/search-image?query=Analyst%20opinion%20column%20screen%20in%20a%20gold%20app%2C%20navy%20dark%20UI%20with%20golden%20author%20cards%20and%20titles%2C%20clean%20editorial%20fintech%20design%2C%20high%20detail&width=800&height=600&seq=sw-taojin-shot1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Gold%20market%20sentiment%20poll%20screen%2C%20deep%20navy%20theme%20with%20warm%20gold%20bar%20charts%2C%20modern%20financial%20app%20interface%2C%20high%20detail&width=800&height=600&seq=sw-taojin-shot2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Daily%20market%20review%20summary%20card%20in%20a%20gold%20app%2C%20navy%20background%20with%20golden%20highlights%2C%20elegant%20fintech%20mobile%20UI%2C%20high%20detail&width=800&height=600&seq=sw-taojin-shot3&orientation=landscape",
    ],
    intro: "汇聚资深分析师观点与市场情绪调研，用多元视角辅助你的黄金投资决策。",
    description:
      "淘金者快讯汇聚多位资深黄金分析师的每日观点，并推出市场情绪调研功能，让你了解当前多空双方的力量对比。平台每日生成一份盘前与盘后速览，帮助你在开盘前就建立对当日行情的合理预期，避免盲目追随消息。",
    features: [
      "资深分析师每日观点专栏",
      "市场多空情绪调研与统计",
      "盘前盘后行情速览",
      "观点收藏与订阅推送",
    ],
    version: "3.2.7",
    size: "44.1 MB",
    platforms: ["Android", "iOS", "Web"],
    updatedAt: "2026-08-22",
    downloads: 297800,
    rating: 4.3,
    free: true,
    officialUrl: "https://example.com/download/taojin-express",
    tags: ["专家观点", "情绪调研", "行情速览"],
  },
];